import { providerApi } from '@/api/ProviderApi'
import { useMutation } from '@tanstack/react-query'

const useCreateAppointmentSchedulingLink = () => {
	return useMutation({
		mutationFn: () => providerApi.createAppointmentSchedulingLink(),
	})
}

export { useCreateAppointmentSchedulingLink }
